<div fxLayout [ngStyle]="getParentStyles()">
  <button type="button" [class.full-width]="block.options.fullWidth" [ngStyle]="getButtonStyles()">
    {{ block.innerText }}
  </button>
</div>
